var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenericModalCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.1581 33.848L48.1673 72.8388L26.9265 51.6572L18.584 59.9997L48.1673 89.583L95.5006 42.2497L87.1581 33.848ZM60.0006 0.833008C27.3407 0.833008 0.833984 27.3397 0.833984 59.9997C0.833984 92.6597 27.3407 119.166 60.0006 119.166C92.6607 119.166 119.167 92.6597 119.167 59.9997C119.167 27.3397 92.6607 0.833008 60.0006 0.833008ZM60.0006 107.333C33.849 107.333 12.6673 86.1513 12.6673 59.9997C12.6673 33.848 33.849 12.6663 60.0006 12.6663C86.1523 12.6663 107.334 33.848 107.334 59.9997C107.334 86.1513 86.1523 107.333 60.0006 107.333Z",
    fill: "#71DE56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericModalCheck);
export default __webpack_public_path__ + "static/media/genericModalCheck.3c9d9400e997420e5d3fd2264a8645ed.svg";
export { ForwardRef as ReactComponent };